module.exports = __webpack_public_path__ + "img/background-tender-black-and-white.da600194.png";